import { render, staticRenderFns } from "./AddPagoModal.vue?vue&type=template&id=0433ae28"
import script from "./AddPagoModal.vue?vue&type=script&lang=js"
export * from "./AddPagoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0433ae28')) {
      api.createRecord('0433ae28', component.options)
    } else {
      api.reload('0433ae28', component.options)
    }
    module.hot.accept("./AddPagoModal.vue?vue&type=template&id=0433ae28", function () {
      api.rerender('0433ae28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddPagoModal.vue"
export default component.exports